/** System role slugs — keep in sync with backend/config/roles.js */
export const ADMIN_ROLE = 'admin';

export const STAFF_CONSOLE_ROLES = new Set([
    'sub_admin',
    'operations',
    'performance_marketing',
    'manager',
    'finance',
]);

export const SALES_ROLES = new Set(['sales', 'sales_user']);

/** Roles that always use the /admin layout (even before permissions load). */
export const ADMIN_WORKSPACE_ROLES = new Set([ADMIN_ROLE, ...STAFF_CONSOLE_ROLES]);
